// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   InstallationBilling.css
───────────────────────────────────────────── */

/* ─── Breadcrumb Navigation ────────────────── */
.installation-billing .breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #64748b;
}

.installation-billing .breadcrumb-link {
  color: #3b82f6;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.installation-billing .breadcrumb-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.installation-billing .breadcrumb-separator {
  color: #94a3b8;
  -webkit-user-select: none;
          user-select: none;
}

.installation-billing .breadcrumb-current {
  color: #0f172a;
  font-weight: 500;
}

/* ─── Layout ───────────────────────────────── */
.installation-billing .billing-layout {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.billing-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 24px;
}

.billing-section h3 {
  margin: 0 0 4px;
  font-size: 18px;
  color: #1e293b;
}

.billing-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% + 24px);
  min-height: 52px;
  margin: -10px -12px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}

.position-rates-section {
  border-color: #dbe4f0;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.billing-section-heading {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.billing-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 11px;
  background: #eff6ff;
  color: #2563eb;
}

.billing-section-heading > span:last-child {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.billing-section-toggle:hover {
  background: #f8fafc;
}

.billing-section-toggle:focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.25);
  outline-offset: 2px;
}

.billing-section-title {
  font-size: 20px;
  font-weight: 700;
  color: #172033;
  line-height: 1.25;
}

.billing-section-summary {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.billing-section-toggle-action {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
}

.billing-section-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #64748b;
  font-size: 24px;
  line-height: 1;
  transform: rotate(-90deg);
  transition: transform 0.2s ease, background 0.15s ease;
}

.billing-section-toggle:hover .billing-section-chevron {
  background: #e2e8f0;
}

.billing-section-chevron.is-expanded {
  transform: rotate(0deg);
}

.position-rates-content {
  margin-top: 18px;
  padding-top: 20px;
  border-top: 1px solid #e8edf4;
}

.position-rates-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  padding: 13px 15px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #f5f9ff;
  color: #1e40af;
}

.position-rates-info svg {
  flex: 0 0 auto;
  margin-top: 1px;
}

.position-rates-info p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
}

.section-desc {
  color: #64748b;
  font-size: 13px;
  margin: 0 0 20px;
}

/* Inline weight inputs inside the position-rates table */
.weight-input {
  width: 96px;
  padding: 8px 10px;
  border: 1px solid #94a3b8;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  transition: border-color 0.2s;
}

.weight-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.position-name-input {
  width: min(100%, 260px);
  padding: 8px 10px;
  border: 1px solid #94a3b8;
  border-radius: 6px;
  background: #fff;
  font: inherit;
}

.position-name-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

/* Add rate form */
.position-rate-editor {
  margin-bottom: 22px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.position-rate-editor-heading {
  padding: 16px 18px 0;
}

.position-rate-editor-heading h4,
.position-rates-table-heading h4 {
  margin: 0;
  color: #1e293b;
  font-size: 15px;
  font-weight: 700;
}

.position-rate-editor-heading p,
.position-rates-table-heading p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.add-rate-form {
  display: grid;
  grid-template-columns: minmax(220px, 1.5fr) repeat(2, minmax(120px, 0.65fr)) auto;
  gap: 14px;
  align-items: end;
  padding: 16px 18px 18px;
  background: #fff;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-field label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.add-rate-form select,
.add-rate-form input {
  padding: 10px 14px;
  min-height: 42px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  transition: all 0.2s;
  font-family: inherit;
}

.add-rate-form select:focus,
.add-rate-form input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.add-rate-form select:hover,
.add-rate-form input:hover {
  border-color: #94a3b8;
}

.btn-add {
  min-height: 42px;
  padding: 10px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  font-weight: 600;
}

.position-rates-table-wrap {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.position-rates-table-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border-bottom: 1px solid #e2e8f0;
}

.position-rates-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.position-rates-table-scroll {
  overflow-x: auto;
}

.position-rates-table th {
  padding: 11px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.position-rates-table td {
  height: 58px;
  padding: 10px 16px;
  vertical-align: middle;
}

.position-rates-table tbody tr:last-child td {
  border-bottom: 0;
}

.position-rates-table tbody tr.is-editing {
  background: #f8fbff;
  box-shadow: inset 3px 0 0 #2563eb;
}

.position-name {
  color: #1e293b;
  font-size: 13px;
  font-weight: 600;
}

.weight-value {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  padding: 5px 10px;
  border: 1px solid #dbeafe;
  border-radius: 7px;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.no-rate {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 7px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.position-rates-actions-heading {
  text-align: right !important;
}

.position-rate-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 7px;
}

.position-rate-actions button {
  margin-left: 0;
}

.position-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 34px;
  padding: 7px 11px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
}

.btn-danger-ghost {
  display: inline-flex;
  align-items: center;
  border: 1px solid #fecaca;
  border-radius: 6px;
  background: #fff;
  color: #dc2626;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.btn-danger-ghost:hover {
  border-color: #fca5a5;
  background: #fef2f2;
}

@media (max-width: 900px) {
  .add-rate-form {
    grid-template-columns: 1fr;
  }

  .position-rate-actions {
    min-width: 190px;
  }
}

@media (max-width: 600px) {
  .position-rates-section {
    padding: 18px;
  }

  .billing-section-toggle {
    width: calc(100% + 16px);
    margin: -8px;
    padding: 8px;
  }

  .billing-section-summary,
  .billing-section-toggle-action > span:first-child {
    display: none;
  }

  .billing-section-title {
    font-size: 17px;
  }

  .position-rates-info {
    padding: 12px;
  }
}

/* Earnings filters */
.earnings-section {
  border-color: #dbe4f0;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.earnings-section-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 22px;
}

.earnings-section-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 11px;
  background: #ecfdf5;
  color: #059669;
}

.earnings-section-header h3 {
  margin-bottom: 3px;
  font-size: 20px;
}

.earnings-section-header p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

.settlement-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(310px, 0.85fr);
  gap: 18px;
  align-items: start;
}

.settlement-generator-card,
.saved-settlements-card {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.settlement-card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px 17px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.settlement-card-heading h4 {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
}

.settlement-card-heading p {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
}

.saved-settlements-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 26px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #4338ca;
  font-size: 12px;
  font-weight: 700;
}

.earnings-filters {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.settlement-generator-card .earnings-filters {
  display: grid;
  grid-template-columns: minmax(210px, 1.4fr) repeat(2, minmax(145px, 0.7fr));
  gap: 13px;
  margin: 0;
  padding: 17px;
}

.earnings-filters label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.earnings-filters select,
.earnings-filters input {
  min-height: 41px;
  padding: 8px 11px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  min-width: 160px;
}

.earnings-filters select:focus,
.earnings-filters input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.settlement-calculate-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 41px;
  grid-column: 1 / -1;
  width: max-content;
  padding-inline: 20px;
}

.saved-settlements-list {
  max-height: 248px;
  overflow-y: auto;
  padding: 7px;
}

.saved-settlement-row {
  display: flex;
  align-items: stretch;
  gap: 6px;
}

.saved-settlement-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  flex: 1 1 auto;
  min-width: 0;
}

.saved-settlement-item:hover {
  border-color: #e2e8f0;
  background: #f8fafc;
}

.saved-settlement-item.is-active {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.saved-settlement-item:disabled {
  cursor: wait;
  opacity: 0.65;
}

.saved-settlement-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.saved-settlement-delete:hover:not(:disabled) {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626;
}

.saved-settlement-delete:disabled {
  cursor: wait;
  opacity: 0.5;
}

.saved-settlement-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.saved-settlement-main strong {
  overflow: hidden;
  color: #1e293b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.saved-settlement-main > span,
.saved-settlement-meta {
  color: #64748b;
  font-size: 11px;
}

.saved-settlement-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  color: #475569;
  font-weight: 600;
}

.saved-settlements-empty {
  padding: 24px 12px;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
}

.earnings-results {
  margin-top: 22px;
}

.settlement-save-bar,
.saved-settlement-banner {
  margin-bottom: 20px;
  border: 1px solid #bbf7d0;
  border-radius: 11px;
  background: #f0fdf4;
}

.settlement-save-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 16px;
}

.settlement-save-copy,
.saved-settlement-banner-main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #166534;
}

.settlement-save-copy > svg,
.saved-settlement-banner-main > svg {
  flex: 0 0 auto;
  margin-top: 1px;
}

.settlement-save-copy > div,
.saved-settlement-banner-main > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.settlement-save-copy strong,
.saved-settlement-banner-main strong {
  color: #14532d;
  font-size: 13px;
}

.settlement-save-copy span,
.saved-settlement-banner-main span {
  font-size: 11px;
  line-height: 1.4;
}

.settlement-save-controls {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 0 1 520px;
}

.settlement-save-controls input {
  min-width: 180px;
  flex: 1 1 auto;
  padding: 9px 11px;
  border: 1px solid #86efac;
  border-radius: 7px;
  background: #fff;
  font: inherit;
  font-size: 13px;
}

.settlement-save-controls input:focus {
  outline: none;
  border-color: #16a34a;
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);
}

.settlement-save-controls button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  white-space: nowrap;
}

.saved-settlement-banner {
  padding: 15px 16px;
}

.saved-settlement-banner-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.saved-settlement-export-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 8px;
}

.saved-settlement-export-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.saved-settlement-label {
  color: #15803d;
  font-size: 10px !important;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.saved-weights-details {
  margin-top: 13px;
  padding-top: 12px;
  border-top: 1px solid #bbf7d0;
}

.saved-weights-details summary {
  width: max-content;
  color: #166534;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.saved-weights-table-wrap {
  overflow-x: auto;
  margin-top: 11px;
  border: 1px solid #dcfce7;
  border-radius: 8px;
  background: #fff;
}

.saved-weights-table {
  width: 100%;
  border-collapse: collapse;
  color: #166534;
  font-size: 12px;
}

.saved-weights-table th,
.saved-weights-table td {
  padding: 9px 11px;
  border-bottom: 1px solid #dcfce7;
  text-align: left;
  white-space: nowrap;
}

.saved-weights-table th {
  background: #f7fee7;
  color: #15803d;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.saved-weights-table tbody tr:last-child td {
  border-bottom: 0;
}

.saved-weights-table strong {
  color: #14532d;
}

.saved-installer-weight {
  font-weight: 700;
}

.saved-weights-empty {
  color: #65a30d;
  text-align: center !important;
}

@media (max-width: 1050px) {
  .settlement-workspace {
    grid-template-columns: 1fr;
  }

  .saved-settlements-list {
    max-height: 280px;
  }
}

@media (max-width: 760px) {
  .settlement-generator-card .earnings-filters {
    grid-template-columns: 1fr;
  }

  .settlement-calculate-btn {
    width: 100%;
  }

  .settlement-save-bar {
    align-items: stretch;
    flex-direction: column;
  }

  .settlement-save-controls {
    align-items: stretch;
    flex: 0 1 auto;
    flex-direction: column;
  }

  .settlement-save-controls input {
    min-width: 0;
  }

  .saved-settlement-banner-top {
    align-items: stretch;
    flex-direction: column;
  }

  .saved-settlement-export-actions button {
    flex: 1 1;
  }
}

/* Installer earnings card */
.installer-earnings-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

.installer-earnings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.installer-earnings-header h4 {
  margin: 0 0 2px;
  font-size: 16px;
  color: #1e293b;
}

.installer-earnings-total {
  display: flex;
  align-items: center;
  gap: 12px;
}

.installer-earnings-header.is-toggleable {
  cursor: pointer;
  transition: background 0.15s ease;
}

.installer-earnings-header.is-toggleable:hover {
  background: #f1f5f9;
}

.installer-earnings-header.is-toggleable:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: -2px;
}

.installer-earnings-card:not(.is-collapsed) .installer-earnings-section-toggle svg {
  transform: rotate(180deg);
}

.installer-earnings-card.is-collapsed .installer-earnings-header {
  border-bottom: 0;
}

.total-earned {
  font-size: 22px;
  font-weight: 700;
  color: #16a34a;
}

.earnings-table {
  border-radius: 0;
}

.earnings-table .earnings-days-cell {
  width: 64px;
  white-space: nowrap;
}

.earnings-table > thead > tr > th,
.earnings-table > tbody > .earnings-installation-row > td,
.earnings-table > tbody > .vacation-earning-row > td,
.earnings-table > tbody > .total-row > td {
  text-align: center;
  vertical-align: middle;
}

.vacation-earning-row {
  background: #f0fdf4;
}

.vacation-earning-row td {
  border-top-color: #bbf7d0;
  border-bottom-color: #bbf7d0;
  color: #166534;
}

.earnings-installation-row {
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.earnings-installation-row:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

.earnings-installation-row.is-expanded {
  background: #eff6ff !important;
  box-shadow: inset 3px 0 0 #2563eb;
}

.earnings-installation-row.is-session-expanded {
  background: #e5e7eb !important;
  box-shadow: inset 3px 0 0 #64748b;
}

.earnings-order-number {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #1d4ed8;
  font-weight: 700;
}

.earnings-order-number svg {
  transition: transform 0.2s ease;
}

.earnings-installation-row.is-expanded .earnings-order-number svg {
  transform: rotate(180deg);
}

.earnings-installation-details-row > td {
  padding: 0;
  border-bottom: 1px solid #bfdbfe;
  background: #f8fbff;
}

.earnings-installation-details-row:hover {
  background: #f8fbff !important;
}

.earnings-installation-details-row.is-session-details > td,
.earnings-installation-details-row.is-session-details:hover {
  border-bottom-color: #cbd5e1;
  background: #e5e7eb !important;
}

.earnings-installation-details {
  padding: 16px 18px 18px;
}

.saved-installation-items-details {
  overflow: hidden;
  margin-top: 14px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
}

.saved-installation-items-toggle {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 13px;
  border: 0;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}

.saved-installation-items-toggle:hover {
  background: #f1f5f9;
}

.saved-installation-items-toggle:focus-visible {
  outline: 2px solid #64748b;
  outline-offset: -2px;
}

.saved-installation-items-toggle svg {
  transition: transform 0.2s ease;
}

.saved-installation-items-details.is-expanded .saved-installation-items-toggle svg {
  transform: rotate(180deg);
}

.saved-installation-items-content {
  border-top: 1px solid #cbd5e1;
}

.saved-installation-items-table-wrap {
  overflow-x: auto;
}

.settlement-items-subtable {
  min-width: 760px;
}

.settlement-calculation-editor {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.settlement-calculation-editor-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 17px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.settlement-calculation-editor-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.settlement-calculation-editor-icon {
  display: grid;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
}

.settlement-calculation-editor-title > div {
  display: grid;
  gap: 1px;
}

.settlement-calculation-editor-title h5,
.settlement-calculation-editor-title p {
  margin: 0;
}

.settlement-calculation-editor-title h5 {
  color: #0f172a;
  font-size: 15px;
}

.settlement-calculation-editor-title p {
  color: #475569;
  font-size: 11px;
}

.settlement-current-amount {
  display: grid;
  min-width: 190px;
  gap: 1px;
  padding-left: 20px;
  border-left: 1px solid #dbe3ef;
  text-align: right;
}

.settlement-current-amount span,
.settlement-current-amount small {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.settlement-current-amount span {
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.settlement-current-amount strong {
  color: #0f172a;
  font-size: 18px;
  line-height: 1.25;
}

.settlement-calculation-editor-body {
  display: grid;
  grid-template-columns: minmax(300px, 0.85fr) minmax(380px, 1.15fr);
  gap: 14px;
  padding: 18px 20px;
}

.settlement-calculation-group {
  min-width: 0;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.settlement-calculation-group-heading {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 13px;
}

.settlement-calculation-group-heading > span {
  display: grid;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 7px;
  background: #e2e8f0;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
}

.settlement-calculation-group-heading > div {
  display: grid;
  gap: 1px;
}

.settlement-calculation-group-heading strong {
  color: #1e293b;
  font-size: 12px;
}

.settlement-calculation-group-heading small {
  color: #64748b;
  font-size: 10px;
}

.settlement-percentage-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 12px;
}

.settlement-percentage-fields > label,
.settlement-target-amount {
  display: grid;
  gap: 6px;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
}

.settlement-percentage-fields > label > small {
  color: #64748b;
  font-size: 10px;
  font-weight: 500;
}

.settlement-percentage-input {
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.settlement-percentage-input:focus-within,
.settlement-target-amount .pzl-money-input:focus-within {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.settlement-percentage-input input {
  width: 100%;
  min-width: 0;
  height: 40px;
  padding: 7px 10px;
  border: 0;
  outline: none;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
}

.settlement-percentage-input > span {
  color: #64748b;
  padding: 0 11px;
  font-size: 12px;
  font-weight: 700;
}

.settlement-target-group.is-active {
  border-color: #93c5fd;
  background: #f8fbff;
  box-shadow: 0 0 0 1px rgba(147, 197, 253, 0.25);
}

.settlement-target-group.is-active .settlement-calculation-group-heading > span {
  background: #2563eb;
  color: #fff;
}

.settlement-target-controls {
  display: grid;
  grid-template-columns: minmax(250px, 1fr) minmax(185px, 0.65fr);
  align-items: center;
  gap: 18px;
}

.settlement-target-switch {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.settlement-target-switch > input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.settlement-target-switch-control {
  position: relative;
  display: block;
  flex: 0 0 auto;
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: #cbd5e1;
  transition: background 0.2s ease;
}

.settlement-target-switch-control > span {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.24);
  transition: transform 0.2s ease;
}

.settlement-target-switch > input:checked + .settlement-target-switch-control {
  background: #2563eb;
}

.settlement-target-switch > input:checked + .settlement-target-switch-control > span {
  transform: translateX(16px);
}

.settlement-target-switch > input:focus-visible + .settlement-target-switch-control {
  outline: 3px solid rgba(59, 130, 246, 0.2);
  outline-offset: 2px;
}

.settlement-target-switch-copy {
  display: grid;
  gap: 2px;
}

.settlement-target-switch-copy strong {
  color: #334155;
  font-size: 12px;
}

.settlement-target-switch-copy small {
  color: #64748b;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.35;
}

.settlement-target-amount .pzl-money-input {
  border-radius: 8px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.2s ease;
}

.settlement-target-amount .pzl-money-input input {
  width: 100%;
  min-width: 0;
  height: 40px;
  outline: none;
  font-size: 14px;
  font-weight: 700;
}

.settlement-target-amount.is-disabled {
  opacity: 0.55;
}

.settlement-calculation-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 20px 16px;
  padding: 10px 12px;
  border: 1px solid;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
}

.settlement-calculation-feedback.is-success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.settlement-calculation-feedback.is-error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.settlement-calculation-editor-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.calculation-day-additional {
  grid-column: 1 / -1;
  color: #047857;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.day-final-amount-editor {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: minmax(150px, 1fr) minmax(210px, auto) auto;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
  padding: 10px;
  border: 1px solid #bfdbfe;
  border-radius: 9px;
  background: #f8fbff;
}

.day-final-assignment {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.day-final-assignment strong {
  color: #334155;
  font-size: 12px;
}

.day-final-assignment small {
  color: #047857;
  font-size: 11px;
  font-weight: 700;
}

.day-final-amount-editor label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.day-final-amount-editor .pzl-money-input {
  flex: 0 0 154px;
  width: 154px;
}

.day-final-amount-editor .pzl-money-input input {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
}

.day-final-amount-editor .pzl-money-input > span {
  display: inline-flex;
  flex: 0 0 42px;
  min-width: 42px;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  padding: 0 7px;
  border-left: 1px solid #e2e8f0;
  white-space: nowrap;
}

.day-final-amount-action {
  display: grid;
  width: min(100%, 460px);
  grid-template-columns: repeat(2, minmax(190px, 1fr));
  justify-self: end;
  gap: 8px;
}

.day-final-amount-action button {
  display: inline-flex;
  width: 100%;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  white-space: nowrap;
}

@media (max-width: 560px) {
  .day-final-amount-action {
    width: 100%;
    grid-template-columns: 1fr;
  }
}

.day-final-amount-feedback {
  grid-column: 1 / -1;
  font-size: 11px;
  font-weight: 700;
  text-align: right;
}

.day-final-amount-feedback.is-success {
  color: #047857;
}

.day-final-amount-feedback.is-error {
  color: #b91c1c;
}

.assignment-days-final-amounts {
  display: grid;
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #dbeafe;
}

.assignment-days-final-amounts > span {
  color: #64748b;
  font-size: 12px;
}

.assignment-day-final-row {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.assignment-day-final-row .day-final-amount-editor {
  margin-top: 0;
}

@media (max-width: 900px) {
  .day-final-amount-editor,
  .assignment-day-final-row {
    grid-template-columns: 1fr;
  }

  .day-final-amount-editor label {
    align-items: flex-start;
    flex-direction: column;
  }
}

.settlement-calculation-global-note {
  display: flex;
  max-width: 620px;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.45;
}

.settlement-calculation-global-note svg {
  flex: 0 0 auto;
  margin-top: 1px;
  color: #2563eb;
}

.settlement-calculation-global-note span {
  display: inline;
}

.settlement-calculation-global-note strong {
  display: block;
  margin-bottom: 1px;
  color: #334155;
}

.settlement-calculation-save-buttons {
  display: grid;
  flex: 0 0 min(100%, 520px);
  width: min(100%, 520px);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.settlement-calculation-save-buttons button {
  display: inline-flex;
  width: 100%;
  height: 42px;
  min-height: 42px;
  box-sizing: border-box;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin: 0;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  transform: none;
  white-space: nowrap;
}

.settlement-calculation-save-buttons button:hover:not(:disabled) {
  transform: none;
}

@media (max-width: 1080px) {
  .settlement-calculation-editor-body {
    grid-template-columns: 1fr;
  }

  .settlement-calculation-editor-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .settlement-calculation-save-buttons {
    align-self: flex-end;
  }
}

@media (max-width: 640px) {
  .settlement-calculation-editor-heading {
    align-items: stretch;
    flex-direction: column;
  }

  .settlement-current-amount {
    padding: 10px 0 0;
    border-top: 1px solid #dbe3ef;
    border-left: 0;
    text-align: left;
  }

  .settlement-percentage-fields,
  .settlement-target-controls,
  .settlement-calculation-save-buttons {
    grid-template-columns: 1fr;
  }

  .settlement-calculation-editor-body,
  .settlement-calculation-editor-heading,
  .settlement-calculation-editor-footer {
    padding-right: 14px;
    padding-left: 14px;
  }
}

.installation-detail-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.installation-detail-summary > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 11px 12px;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #fff;
}

.installation-detail-summary span {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.installation-detail-summary strong {
  color: #1e293b;
  font-size: 13px;
}

.installation-calculation {
  margin-bottom: 14px;
  padding: 16px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.installation-calculation-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.calculation-eyebrow {
  display: block;
  margin-bottom: 2px;
  color: #2563eb;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.installation-calculation-heading h5 {
  margin: 0;
  color: #0f172a;
  font-size: 15px;
}

.calculation-position {
  padding: 5px 9px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
}

.calculation-flow {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) auto minmax(120px, 1fr) auto minmax(135px, 1fr) auto minmax(110px, 0.8fr) auto minmax(135px, 1fr);
  align-items: stretch;
  gap: 7px;
}

.calculation-step {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-height: 58px;
  padding: 9px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.calculation-step.is-highlighted {
  border-color: #bfdbfe;
  background: #eff6ff;
}

.calculation-step span {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.calculation-step strong {
  color: #0f172a;
  font-size: 13px;
  white-space: nowrap;
}

.calculation-operator {
  align-self: center;
  color: #64748b;
  font-size: 18px;
  font-weight: 700;
}

.employee-calculation-result {
  margin-top: 12px;
  padding: 13px;
  border: 1px solid #bbf7d0;
  border-radius: 9px;
  background: #f0fdf4;
}

.employee-calculation-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.employee-calculation-meta > span {
  display: flex;
  flex-direction: column;
  gap: 3px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.employee-calculation-meta strong {
  color: #166534;
  font-size: 13px;
  text-transform: none;
}

.employee-calculation-formula {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  border-radius: 7px;
  background: #fff;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.employee-calculation-formula strong {
  color: #15803d;
  font-size: 18px;
}

.calculation-days {
  overflow: hidden;
  border: 1px solid #dcfce7;
  border-radius: 8px;
  background: #fff;
}

.calculation-days-title {
  display: block;
  padding: 8px 11px;
  border-bottom: 1px solid #dcfce7;
  background: #f7fee7;
  color: #3f6212;
  font-size: 11px;
}

.calculation-day-row {
  display: grid;
  grid-template-columns: 90px minmax(230px, 1fr) auto minmax(90px, auto);
  align-items: center;
  gap: 10px;
  padding: 8px 11px;
  border-bottom: 1px solid #f1f5f9;
  color: #475569;
  font-size: 12px;
}

.calculation-day-date {
  color: #64748b;
  font-weight: 700;
}

.calculation-day-formula {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.calculation-day-equals {
  color: #94a3b8;
  font-weight: 700;
}

.calculation-day-row > strong {
  color: #15803d;
  text-align: right;
  white-space: nowrap;
}

.employee-calculation-formula.is-total {
  justify-content: flex-end;
  border-radius: 0;
  background: #f0fdf4;
}

.employee-calculation-result p {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 10px;
  line-height: 1.45;
}

.employee-calculation-result.is-manual > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.employee-calculation-result.is-manual span {
  color: #166534;
  font-size: 12px;
  font-weight: 700;
}

.employee-calculation-result.is-manual strong {
  color: #15803d;
  font-size: 18px;
}

.installation-calculation.is-unavailable {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 11px 12px;
  color: #64748b;
}

.installation-calculation.is-unavailable div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.installation-calculation.is-unavailable strong {
  color: #475569;
  font-size: 12px;
}

.installation-calculation.is-unavailable span {
  font-size: 11px;
}

.installation-usl-form {
  display: grid;
  grid-template-columns: minmax(190px, 0.7fr) minmax(240px, 1.3fr) auto;
  gap: 11px;
  align-items: end;
  padding: 13px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #fff;
}

.installation-usl-form-heading {
  display: flex;
  flex-direction: column;
  gap: 2px;
  grid-column: 1 / -1;
}

.installation-usl-form-heading strong {
  color: #1e293b;
  font-size: 13px;
}

.installation-usl-form-heading span {
  color: #64748b;
  font-size: 11px;
}

.installation-usl-form label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #475569;
  font-size: 11px;
  font-weight: 600;
}

.installation-usl-form input {
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 400;
}

.installation-usl-form input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.installation-usl-form button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 38px;
  white-space: nowrap;
}

.installation-usl-error {
  grid-column: 1 / -1;
  color: #b91c1c;
  font-size: 11px;
}

.snapshot-usl-note {
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
}

.earned-cell {
  font-weight: 700;
  color: #16a34a;
}

.total-row {
  background: #f0fdf4 !important;
}

.total-row td {
  border-top: 2px solid #bbf7d0;
  padding: 10px 12px;
}

@media (max-width: 800px) {
  .installation-detail-summary,
  .installation-usl-form {
    grid-template-columns: 1fr;
  }

  .installation-calculation-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .calculation-flow {
    grid-template-columns: 1fr;
  }

  .calculation-operator {
    transform: rotate(90deg);
    justify-self: center;
  }

  .employee-calculation-meta {
    grid-template-columns: 1fr;
  }

  .employee-calculation-formula {
    flex-wrap: wrap;
  }

  .calculation-day-row {
    grid-template-columns: 1fr auto;
  }

  .calculation-day-formula {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  .calculation-day-equals {
    display: none;
  }

  .installation-usl-form button {
    width: 100%;
  }
}

/* Shared */
.error-banner {
  background: #fee2e2;
  color: #991b1b;
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #fca5a5;
}

.loading-text {
  color: #64748b;
  padding: 24px;
  text-align: center;
  font-style: italic;
}

/* Data table (shared) */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.data-table th {
  background: #f1f5f9;
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}
.data-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
}
.data-table tbody tr:hover { background: #f8fafc; }

.no-data-cell {
  text-align: center;
  color: #94a3b8;
  padding: 24px;
  font-style: italic;
}
.no-data-text { color: #94a3b8; font-style: italic; font-size: 13px; }
.numeric-cell { text-align: right; }
.actions-cell { white-space: nowrap; }
.actions-cell button { margin-left: 4px; }
.installer-position { font-size: 12px; color: #64748b; }

/* Unassigned installations warning */
.unassigned-warning {
  border: 1.5px solid #fde68a;
  border-radius: 10px;
  background: #fffbeb;
  margin-bottom: 20px;
  overflow: hidden;
}
.unassigned-warning-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #fef9c3;
  border-bottom: 1px solid #fde68a;
  flex-wrap: wrap;
  cursor: pointer;
  transition: background 0.15s ease;
}
.unassigned-warning-header:hover {
  background: #fef3c7;
}
.unassigned-warning-header:focus-visible {
  outline: 2px solid #d97706;
  outline-offset: -2px;
}
.unassigned-warning.is-collapsed .unassigned-warning-header {
  border-bottom: 0;
}
.unassigned-warning-badge {
  background: #f59e0b;
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}
.unassigned-warning-copy {
  display: flex;
  min-width: 240px;
  flex: 1 1 520px;
  flex-direction: column;
  gap: 2px;
}
.unassigned-warning-hint {
  font-size: 12px;
  color: #92400e;
}
.unassigned-warning-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 34px;
  margin-left: auto;
  padding: 6px 10px;
  border: 1px solid #f59e0b;
  border-radius: 7px;
  background: #fff;
  color: #92400e;
  pointer-events: none;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}
.unassigned-warning-toggle:hover {
  background: #fffbeb;
}
.unassigned-warning-toggle:focus-visible {
  outline: 2px solid #d97706;
  outline-offset: 2px;
}
.unassigned-warning-toggle svg {
  transition: transform 0.2s ease;
}
.unassigned-warning.is-expanded .unassigned-warning-toggle svg {
  transform: rotate(180deg);
}
.unassigned-warning-content {
  overflow-x: auto;
}
.unassigned-warning .data-table { margin: 0; }
.unassigned-warning .data-table td,
.unassigned-warning .data-table th {
  padding: 8px 12px;
  font-size: 13px;
  text-align: center;
  vertical-align: middle;
}
.order-cell { font-weight: 600; font-family: monospace; }

/* All installations in the selected settlement period */
.period-installations-card {
  margin-bottom: 20px;
  overflow: hidden;
  border: 1px solid #dbe4ef;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgb(15 23 42 / 4%);
}

.period-installations-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 18px;
  border: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-align: left;
  transition: background 0.15s ease;
}

.period-installations-header:hover {
  background: #f1f5f9;
}

.period-installations-header:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: -2px;
}

.period-installations-card.is-collapsed .period-installations-header {
  border-bottom: 0;
}

.period-installations-header h4 {
  margin: 0 0 3px;
  color: #0f172a;
  font-size: 15px;
}

.period-installations-header p {
  max-width: 760px;
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.period-installations-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 9px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 13px;
  font-weight: 800;
}

.period-installations-header-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 9px;
}

.period-installations-section-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 34px;
  padding: 6px 10px;
  border: 1px solid #818cf8;
  border-radius: 7px;
  background: #fff;
  color: #4338ca;
  pointer-events: none;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.period-installations-section-toggle:hover {
  background: #eef2ff;
}

.period-installations-section-toggle:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
}

.period-installations-section-toggle svg {
  transition: transform 0.2s ease;
}

.period-installations-card.is-expanded .period-installations-section-toggle svg {
  transform: rotate(180deg);
}

.period-installations-state {
  padding: 28px 18px;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.period-installations-table-wrap {
  overflow-x: auto;
}

.period-installations-table {
  min-width: 850px;
  margin: 0;
}

.period-installations-table th,
.period-installations-table td {
  padding: 10px 12px;
  font-size: 13px;
}

.period-installations-table > thead > tr > th,
.period-installations-table > tbody > .period-installation-row > td {
  text-align: center;
  vertical-align: middle;
}

.period-installation-row {
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.period-installation-row:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: -2px;
}

.period-installation-row.is-expanded:not(.has-zero-usl) {
  background: #eef2ff;
}

.period-installation-row.has-zero-usl,
.period-installation-row.has-zero-usl:hover {
  background: #fff1f2;
}

.period-installation-row.has-zero-usl td:first-child {
  box-shadow: inset 3px 0 0 #fb7185;
}

.period-installation-usl {
  color: #166534;
  font-weight: 700;
  white-space: nowrap;
}

.period-installation-usl.is-zero {
  color: #be123c;
}

.period-installation-actions {
  text-align: right;
  white-space: nowrap;
}

.period-installation-actions button,
.period-usl-entry button,
.period-usl-form-actions button,
.period-usl-add-form button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.period-installation-toggle svg {
  transition: transform 0.2s ease;
}

.period-installation-toggle.is-expanded svg {
  transform: rotate(180deg);
}

.period-installation-editor-row > td {
  padding: 0 !important;
  border-bottom-color: #cbd5e1;
  background: #f8fafc;
}

.period-usl-editor {
  padding: 16px 20px 18px;
  border-left: 3px solid #6366f1;
}

.period-installation-breakdown {
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid #c7d2fe;
  border-radius: 9px;
  background: #fff;
}

.period-installation-breakdown-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 13px;
  border-bottom: 1px solid #e0e7ff;
  background: #eef2ff;
}

.period-installation-breakdown.is-collapsible .period-installation-breakdown-heading {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #e0e7ff;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.period-installation-breakdown.is-collapsed .period-installation-breakdown-heading {
  border-bottom: 0;
}

.period-installation-breakdown-heading > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.period-installation-breakdown-heading strong {
  color: #312e81;
  font-size: 13px;
}

.period-installation-breakdown-heading span {
  color: #6366f1;
  font-size: 11px;
  font-weight: 700;
}

.period-installation-breakdown-heading > .period-installation-breakdown-heading-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
}

.period-installation-breakdown-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.period-installation-breakdown-toggle svg {
  transition: transform 0.2s ease;
}

.period-installation-breakdown.is-expanded .period-installation-breakdown-toggle svg {
  transform: rotate(180deg);
}

.period-installation-breakdown-table-wrap {
  overflow-x: auto;
}

.period-installation-breakdown-table {
  width: 100%;
  min-width: 620px;
  border-collapse: collapse;
}

.period-installation-breakdown-table th,
.period-installation-breakdown-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #eef2f7;
  color: #475569;
  font-size: 12px;
  text-align: left;
}

.period-installation-breakdown-table th {
  background: #f8fafc;
  color: #64748b;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.period-installation-breakdown-table .numeric-cell {
  text-align: center;
}

.period-installation-breakdown-table tbody strong {
  color: #1e293b;
}

.period-installation-breakdown-table tfoot td {
  border-bottom: 0;
  background: #f8fafc;
  color: #0f172a;
  font-weight: 800;
}

.period-installation-breakdown-empty {
  padding: 16px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.period-usl-editor-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.period-usl-editor-heading > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.period-usl-editor-heading strong {
  color: #0f172a;
  font-size: 13px;
}

.period-usl-editor-heading span,
.period-usl-no-entries {
  color: #64748b;
  font-size: 11px;
}

.period-usl-no-entries {
  padding: 5px 9px;
  border-radius: 6px;
  background: #e2e8f0;
}

.period-usl-entries {
  display: grid;
  gap: 8px;
  margin-bottom: 12px;
}

.period-usl-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 9px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.period-usl-entry > div:not(.period-usl-form-actions) {
  display: flex;
  min-width: 0;
  flex: 1 1;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.period-usl-entry strong {
  overflow: hidden;
  color: #334155;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.period-usl-entry span {
  color: #0f172a;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.period-usl-inline-form,
.period-usl-add-form {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(130px, 0.45fr) minmax(220px, 1fr) auto;
  align-items: end;
  gap: 10px;
}

.period-usl-add-form {
  padding: 12px;
  border: 1px dashed #a5b4fc;
  border-radius: 9px;
  background: #eef2ff;
}

.period-usl-inline-form label,
.period-usl-add-form label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.period-usl-inline-form input,
.period-usl-add-form input {
  min-width: 0;
  height: 36px;
  padding: 7px 9px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #0f172a;
  font: inherit;
  font-size: 13px;
}

.period-usl-inline-form input:focus,
.period-usl-add-form input:focus {
  outline: 2px solid #c7d2fe;
  border-color: #6366f1;
}

.period-usl-form-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.period-usl-error {
  margin-top: 8px;
  color: #be123c;
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 760px) {
  .period-installations-header,
  .period-usl-editor-heading {
    align-items: flex-start;
  }

  .period-installations-header {
    flex-wrap: wrap;
  }

  .period-installations-header-actions {
    width: 100%;
    justify-content: space-between;
  }

  .period-usl-inline-form,
  .period-usl-add-form {
    grid-template-columns: 1fr;
  }

  .period-usl-form-actions {
    justify-content: flex-start;
  }
}

/* Buttons */
.btn-primary {
  background: #2563eb;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.15s;
}
.btn-primary:hover { background: #1d4ed8; }
.btn-primary:disabled { background: #93c5fd; cursor: not-allowed; }

.btn-secondary {
  background: #f1f5f9;
  color: #374151;
  border: 1px solid #cbd5e1;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.15s;
}
.btn-secondary:hover { background: #e2e8f0; }

.btn-success {
  background: #16a34a;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}
.btn-success:hover { background: #15803d; }

.btn-danger {
  background: #ef4444;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}
.btn-danger:hover { background: #dc2626; }

.btn-sm { padding: 4px 10px; font-size: 12px; }

.position-rate-actions .position-action-btn {
  margin-left: 0;
  padding: 7px 11px;
  font-size: 12px;
  font-weight: 600;
}

.position-rate-actions .position-action-btn:disabled {
  cursor: wait;
  opacity: 0.7;
}

.position-rate-actions .position-edit-btn,
.position-rate-actions .position-cancel-btn {
  width: max-content;
  min-height: auto;
  flex: 0 0 auto;
  padding: 3px 6px;
  font-size: 12px;
}

.position-rate-actions .position-edit-btn {
  border-color: transparent;
  background: transparent;
}

.position-rate-actions .position-edit-btn:hover {
  border-color: #cbd5e1;
  background: #f1f5f9;
}
.pzl-price-list-step-heading {
  display: flex;
  gap: 11px;
  align-items: center;
  padding: 18px 0 12px;
}

.pzl-price-list-step-heading > span {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #7c3aed;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}

.pzl-price-list-step-heading h4,
.pzl-price-list-step-heading p {
  margin: 0;
}

.pzl-price-list-step-heading h4 {
  color: #1e293b;
  font-size: 15px;
}

.pzl-price-list-step-heading p {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.pzl-price-list-step-heading.is-compact {
  padding-top: 0;
}

.pzl-price-list-form,
.pzl-order-editor {
  display: grid;
  gap: 16px;
}

.pzl-price-list-options {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.pzl-price-option {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 34px;
  padding: 7px 12px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  cursor: pointer;
}

.pzl-price-option input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.pzl-price-option.is-selected {
  border-color: #7c3aed;
  background: #f5f3ff;
  color: #6d28d9;
  box-shadow: 0 0 0 1px #7c3aed;
}

.pzl-price-option span,
.pzl-price-option small,
.pzl-order-editor-heading > div {
  display: grid;
  gap: 4px;
}

.pzl-price-option small,
.pzl-order-editor-heading span {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
}

.pzl-price-list-actions,
.pzl-order-editor-controls,
.pzl-order-editor-heading,
.pzl-order-editor-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.pzl-price-list-actions,
.pzl-order-editor-actions {
  justify-content: flex-start;
}

.pzl-order-editor-actions {
  display: grid;
  justify-items: start;
  width: 100%;
  gap: 10px;
}

.pzl-order-save-success {
  color: #15803d;
  font-size: 12px;
  font-weight: 700;
}

.pzl-order-save-buttons {
  display: flex;
  gap: 10px;
}

.pzl-order-save-buttons.has-two-actions {
  display: grid;
  width: min(100%, 560px);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pzl-order-save-buttons.has-two-actions button {
  justify-content: center;
  width: 100%;
  min-height: 36px;
}

.pzl-order-global-note {
  margin: -4px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.pzl-price-list-actions label,
.pzl-order-editor-controls label {
  display: grid;
  gap: 6px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.pzl-money-input {
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
}

.pzl-money-input input {
  width: 110px;
  height: 34px;
  padding: 6px 9px;
  border: 0 !important;
}

.pzl-money-input > span {
  padding: 0 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.pzl-price-list-success {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #ecfdf5;
  color: #047857;
}

.pzl-price-current-value {
  flex: 1 1;
  color: #64748b;
  font-size: 12px;
}

.saved-session-pzl-price-list {
  overflow: hidden;
  border: 1px solid #c4b5fd;
  border-radius: 12px;
  background: linear-gradient(135deg, #fff 0%, #faf5ff 100%);
}

.saved-session-pzl-toggle {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 16px 18px;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.saved-session-pzl-toggle:hover {
  background: rgba(245, 243, 255, 0.75);
}

.saved-session-pzl-heading-copy {
  display: grid;
  gap: 3px;
}

.saved-session-pzl-heading-copy strong {
  color: #1e293b;
  font-size: 15px;
}

.saved-session-pzl-toggle-action {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.saved-session-pzl-content {
  display: grid;
  gap: 14px;
  padding: 16px 18px 18px;
  border-top: 1px solid #ddd6fe;
}

.saved-session-pzl-description {
  margin: 0;
  color: #64748b;
  font-size: 12px;
}

.pzl-price-list-form.is-session {
  padding-top: 4px;
}

.pzl-order-editor {
  margin: 14px 0;
  padding: 14px;
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  background: #faf5ff;
}

.pzl-order-editor-heading {
  justify-content: space-between;
  align-items: flex-start;
}

.pzl-source-badge {
  padding: 4px 8px;
  border-radius: 999px;
  background: #ede9fe;
  color: #6d28d9 !important;
  font-weight: 700;
}

.pzl-source-badge.is-override {
  background: #ffedd5;
  color: #c2410c !important;
}

.pzl-use-price-list {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
}

.pzl-inline-badge {
  display: block;
  width: fit-content;
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #ede9fe;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.note-settlement-editor {
  margin: 14px 0;
}

.note-settlement-mode-options,
.note-settlement-manual-amounts {
  display: grid;
  gap: 10px;
}

.note-settlement-mode-options label {
  display: flex;
  gap: 9px;
  align-items: center;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.note-settlement-equal-amount,
.note-settlement-manual-amounts label {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.note-settlement-manual-amounts label {
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

@media (max-width: 700px) {
  .note-settlement-equal-amount,
  .note-settlement-manual-amounts label {
    align-items: stretch;
    flex-direction: column;
  }
}

@media (max-width: 900px) {
  .pzl-price-list-actions,
  .pzl-order-editor-controls,
  .pzl-order-editor-heading {
    align-items: stretch;
    flex-direction: column;
  }

  .saved-session-pzl-toggle-action .pzl-source-badge {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/InstallationBilling.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iFAAiF;EACjF,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2EAA2E;EAC3E,SAAS;EACT,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,SAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kEAAkE;EAClE,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oDAAoD;EACpD,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2IAA2I;EAC3I,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qEAAqE;EACrE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA,gBAAgB,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACrE,gBAAgB,iBAAiB,EAAE;AACnC,gBAAgB,mBAAmB,EAAE;AACrC,uBAAuB,gBAAgB,EAAE;AACzC,sBAAsB,eAAe,EAAE,cAAc,EAAE;;AAEvD,qCAAqC;AACrC;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wDAAwD;AAC1D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA,kCAAkC,SAAS,EAAE;AAC7C;;EAEE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA,cAAc,gBAAgB,EAAE,sBAAsB,EAAE;;AAExD,wDAAwD;AACxD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,oEAAoE;EACpE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,mBAAmB,EAAE,mBAAmB,EAAE;;AAElE;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC,UAAU,iBAAiB,EAAE,eAAe,EAAE;;AAE9C;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;AACF;;AAEA;EACE;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ─────────────────────────────────────────────\n   InstallationBilling.css\n───────────────────────────────────────────── */\n\n/* ─── Breadcrumb Navigation ────────────────── */\n.installation-billing .breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.installation-billing .breadcrumb-link {\n  color: #3b82f6;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.installation-billing .breadcrumb-link:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.installation-billing .breadcrumb-separator {\n  color: #94a3b8;\n  user-select: none;\n}\n\n.installation-billing .breadcrumb-current {\n  color: #0f172a;\n  font-weight: 500;\n}\n\n/* ─── Layout ───────────────────────────────── */\n.installation-billing .billing-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.billing-section {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 24px;\n}\n\n.billing-section h3 {\n  margin: 0 0 4px;\n  font-size: 18px;\n  color: #1e293b;\n}\n\n.billing-section-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: calc(100% + 24px);\n  min-height: 52px;\n  margin: -10px -12px;\n  padding: 10px 12px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.position-rates-section {\n  border-color: #dbe4f0;\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n}\n\n.billing-section-heading {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.billing-section-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  border-radius: 11px;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.billing-section-heading > span:last-child {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.billing-section-toggle:hover {\n  background: #f8fafc;\n}\n\n.billing-section-toggle:focus-visible {\n  outline: 3px solid rgba(37, 99, 235, 0.25);\n  outline-offset: 2px;\n}\n\n.billing-section-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #172033;\n  line-height: 1.25;\n}\n\n.billing-section-summary {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.billing-section-toggle-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.billing-section-chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 24px;\n  line-height: 1;\n  transform: rotate(-90deg);\n  transition: transform 0.2s ease, background 0.15s ease;\n}\n\n.billing-section-toggle:hover .billing-section-chevron {\n  background: #e2e8f0;\n}\n\n.billing-section-chevron.is-expanded {\n  transform: rotate(0deg);\n}\n\n.position-rates-content {\n  margin-top: 18px;\n  padding-top: 20px;\n  border-top: 1px solid #e8edf4;\n}\n\n.position-rates-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding: 13px 15px;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  background: #f5f9ff;\n  color: #1e40af;\n}\n\n.position-rates-info svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n\n.position-rates-info p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.section-desc {\n  color: #64748b;\n  font-size: 13px;\n  margin: 0 0 20px;\n}\n\n/* Inline weight inputs inside the position-rates table */\n.weight-input {\n  width: 96px;\n  padding: 8px 10px;\n  border: 1px solid #94a3b8;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  transition: border-color 0.2s;\n}\n\n.weight-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.position-name-input {\n  width: min(100%, 260px);\n  padding: 8px 10px;\n  border: 1px solid #94a3b8;\n  border-radius: 6px;\n  background: #fff;\n  font: inherit;\n}\n\n.position-name-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n/* Add rate form */\n.position-rate-editor {\n  margin-bottom: 22px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.position-rate-editor-heading {\n  padding: 16px 18px 0;\n}\n\n.position-rate-editor-heading h4,\n.position-rates-table-heading h4 {\n  margin: 0;\n  color: #1e293b;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.position-rate-editor-heading p,\n.position-rates-table-heading p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.add-rate-form {\n  display: grid;\n  grid-template-columns: minmax(220px, 1.5fr) repeat(2, minmax(120px, 0.65fr)) auto;\n  gap: 14px;\n  align-items: end;\n  padding: 16px 18px 18px;\n  background: #fff;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-field label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.add-rate-form select,\n.add-rate-form input {\n  padding: 10px 14px;\n  min-height: 42px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #fff;\n  transition: all 0.2s;\n  font-family: inherit;\n}\n\n.add-rate-form select:focus,\n.add-rate-form input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.add-rate-form select:hover,\n.add-rate-form input:hover {\n  border-color: #94a3b8;\n}\n\n.btn-add {\n  min-height: 42px;\n  padding: 10px 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.position-rates-table-wrap {\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.position-rates-table-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 18px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.position-rates-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 30px;\n  height: 26px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.position-rates-table-scroll {\n  overflow-x: auto;\n}\n\n.position-rates-table th {\n  padding: 11px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.position-rates-table td {\n  height: 58px;\n  padding: 10px 16px;\n  vertical-align: middle;\n}\n\n.position-rates-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.position-rates-table tbody tr.is-editing {\n  background: #f8fbff;\n  box-shadow: inset 3px 0 0 #2563eb;\n}\n\n.position-name {\n  color: #1e293b;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.weight-value {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 46px;\n  padding: 5px 10px;\n  border: 1px solid #dbeafe;\n  border-radius: 7px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.no-rate {\n  display: inline-flex;\n  padding: 5px 9px;\n  border-radius: 7px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.position-rates-actions-heading {\n  text-align: right !important;\n}\n\n.position-rate-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 7px;\n}\n\n.position-rate-actions button {\n  margin-left: 0;\n}\n\n.position-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 34px;\n  padding: 7px 11px;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.btn-danger-ghost {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  background: #fff;\n  color: #dc2626;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.btn-danger-ghost:hover {\n  border-color: #fca5a5;\n  background: #fef2f2;\n}\n\n@media (max-width: 900px) {\n  .add-rate-form {\n    grid-template-columns: 1fr;\n  }\n\n  .position-rate-actions {\n    min-width: 190px;\n  }\n}\n\n@media (max-width: 600px) {\n  .position-rates-section {\n    padding: 18px;\n  }\n\n  .billing-section-toggle {\n    width: calc(100% + 16px);\n    margin: -8px;\n    padding: 8px;\n  }\n\n  .billing-section-summary,\n  .billing-section-toggle-action > span:first-child {\n    display: none;\n  }\n\n  .billing-section-title {\n    font-size: 17px;\n  }\n\n  .position-rates-info {\n    padding: 12px;\n  }\n}\n\n/* Earnings filters */\n.earnings-section {\n  border-color: #dbe4f0;\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n}\n\n.earnings-section-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 22px;\n}\n\n.earnings-section-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  border-radius: 11px;\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.earnings-section-header h3 {\n  margin-bottom: 3px;\n  font-size: 20px;\n}\n\n.earnings-section-header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.settlement-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(310px, 0.85fr);\n  gap: 18px;\n  align-items: start;\n}\n\n.settlement-generator-card,\n.saved-settlements-card {\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.settlement-card-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 15px 17px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.settlement-card-heading h4 {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n  color: #1e293b;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.settlement-card-heading p {\n  margin: 3px 0 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.saved-settlements-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 26px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #e0e7ff;\n  color: #4338ca;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.earnings-filters {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n}\n\n.settlement-generator-card .earnings-filters {\n  display: grid;\n  grid-template-columns: minmax(210px, 1.4fr) repeat(2, minmax(145px, 0.7fr));\n  gap: 13px;\n  margin: 0;\n  padding: 17px;\n}\n\n.earnings-filters label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.earnings-filters select,\n.earnings-filters input {\n  min-height: 41px;\n  padding: 8px 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #fff;\n  min-width: 160px;\n}\n\n.earnings-filters select:focus,\n.earnings-filters input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.settlement-calculate-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 41px;\n  grid-column: 1 / -1;\n  width: max-content;\n  padding-inline: 20px;\n}\n\n.saved-settlements-list {\n  max-height: 248px;\n  overflow-y: auto;\n  padding: 7px;\n}\n\n.saved-settlement-row {\n  display: flex;\n  align-items: stretch;\n  gap: 6px;\n}\n\n.saved-settlement-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 10px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.saved-settlement-item:hover {\n  border-color: #e2e8f0;\n  background: #f8fafc;\n}\n\n.saved-settlement-item.is-active {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n}\n\n.saved-settlement-item:disabled {\n  cursor: wait;\n  opacity: 0.65;\n}\n\n.saved-settlement-delete {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 38px;\n  border: 1px solid transparent;\n  border-radius: 7px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.saved-settlement-delete:hover:not(:disabled) {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.saved-settlement-delete:disabled {\n  cursor: wait;\n  opacity: 0.5;\n}\n\n.saved-settlement-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.saved-settlement-main strong {\n  overflow: hidden;\n  color: #1e293b;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.saved-settlement-main > span,\n.saved-settlement-meta {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.saved-settlement-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  color: #475569;\n  font-weight: 600;\n}\n\n.saved-settlements-empty {\n  padding: 24px 12px;\n  color: #94a3b8;\n  font-size: 12px;\n  text-align: center;\n}\n\n.earnings-results {\n  margin-top: 22px;\n}\n\n.settlement-save-bar,\n.saved-settlement-banner {\n  margin-bottom: 20px;\n  border: 1px solid #bbf7d0;\n  border-radius: 11px;\n  background: #f0fdf4;\n}\n\n.settlement-save-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 14px 16px;\n}\n\n.settlement-save-copy,\n.saved-settlement-banner-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  color: #166534;\n}\n\n.settlement-save-copy > svg,\n.saved-settlement-banner-main > svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n\n.settlement-save-copy > div,\n.saved-settlement-banner-main > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.settlement-save-copy strong,\n.saved-settlement-banner-main strong {\n  color: #14532d;\n  font-size: 13px;\n}\n\n.settlement-save-copy span,\n.saved-settlement-banner-main span {\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.settlement-save-controls {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex: 0 1 520px;\n}\n\n.settlement-save-controls input {\n  min-width: 180px;\n  flex: 1 1 auto;\n  padding: 9px 11px;\n  border: 1px solid #86efac;\n  border-radius: 7px;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n}\n\n.settlement-save-controls input:focus {\n  outline: none;\n  border-color: #16a34a;\n  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.1);\n}\n\n.settlement-save-controls button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 38px;\n  white-space: nowrap;\n}\n\n.saved-settlement-banner {\n  padding: 15px 16px;\n}\n\n.saved-settlement-banner-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.saved-settlement-export-actions {\n  display: flex;\n  flex: 0 0 auto;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.saved-settlement-export-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.saved-settlement-label {\n  color: #15803d;\n  font-size: 10px !important;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.saved-weights-details {\n  margin-top: 13px;\n  padding-top: 12px;\n  border-top: 1px solid #bbf7d0;\n}\n\n.saved-weights-details summary {\n  width: max-content;\n  color: #166534;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.saved-weights-table-wrap {\n  overflow-x: auto;\n  margin-top: 11px;\n  border: 1px solid #dcfce7;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.saved-weights-table {\n  width: 100%;\n  border-collapse: collapse;\n  color: #166534;\n  font-size: 12px;\n}\n\n.saved-weights-table th,\n.saved-weights-table td {\n  padding: 9px 11px;\n  border-bottom: 1px solid #dcfce7;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.saved-weights-table th {\n  background: #f7fee7;\n  color: #15803d;\n  font-size: 10px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.saved-weights-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.saved-weights-table strong {\n  color: #14532d;\n}\n\n.saved-installer-weight {\n  font-weight: 700;\n}\n\n.saved-weights-empty {\n  color: #65a30d;\n  text-align: center !important;\n}\n\n@media (max-width: 1050px) {\n  .settlement-workspace {\n    grid-template-columns: 1fr;\n  }\n\n  .saved-settlements-list {\n    max-height: 280px;\n  }\n}\n\n@media (max-width: 760px) {\n  .settlement-generator-card .earnings-filters {\n    grid-template-columns: 1fr;\n  }\n\n  .settlement-calculate-btn {\n    width: 100%;\n  }\n\n  .settlement-save-bar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .settlement-save-controls {\n    align-items: stretch;\n    flex: 0 1 auto;\n    flex-direction: column;\n  }\n\n  .settlement-save-controls input {\n    min-width: 0;\n  }\n\n  .saved-settlement-banner-top {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .saved-settlement-export-actions button {\n    flex: 1 1 0;\n  }\n}\n\n/* Installer earnings card */\n.installer-earnings-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.installer-earnings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.installer-earnings-header h4 {\n  margin: 0 0 2px;\n  font-size: 16px;\n  color: #1e293b;\n}\n\n.installer-earnings-total {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.installer-earnings-header.is-toggleable {\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.installer-earnings-header.is-toggleable:hover {\n  background: #f1f5f9;\n}\n\n.installer-earnings-header.is-toggleable:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: -2px;\n}\n\n.installer-earnings-card:not(.is-collapsed) .installer-earnings-section-toggle svg {\n  transform: rotate(180deg);\n}\n\n.installer-earnings-card.is-collapsed .installer-earnings-header {\n  border-bottom: 0;\n}\n\n.total-earned {\n  font-size: 22px;\n  font-weight: 700;\n  color: #16a34a;\n}\n\n.earnings-table {\n  border-radius: 0;\n}\n\n.earnings-table .earnings-days-cell {\n  width: 64px;\n  white-space: nowrap;\n}\n\n.earnings-table > thead > tr > th,\n.earnings-table > tbody > .earnings-installation-row > td,\n.earnings-table > tbody > .vacation-earning-row > td,\n.earnings-table > tbody > .total-row > td {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.vacation-earning-row {\n  background: #f0fdf4;\n}\n\n.vacation-earning-row td {\n  border-top-color: #bbf7d0;\n  border-bottom-color: #bbf7d0;\n  color: #166534;\n}\n\n.earnings-installation-row {\n  cursor: pointer;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.earnings-installation-row:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: -2px;\n}\n\n.earnings-installation-row.is-expanded {\n  background: #eff6ff !important;\n  box-shadow: inset 3px 0 0 #2563eb;\n}\n\n.earnings-installation-row.is-session-expanded {\n  background: #e5e7eb !important;\n  box-shadow: inset 3px 0 0 #64748b;\n}\n\n.earnings-order-number {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #1d4ed8;\n  font-weight: 700;\n}\n\n.earnings-order-number svg {\n  transition: transform 0.2s ease;\n}\n\n.earnings-installation-row.is-expanded .earnings-order-number svg {\n  transform: rotate(180deg);\n}\n\n.earnings-installation-details-row > td {\n  padding: 0;\n  border-bottom: 1px solid #bfdbfe;\n  background: #f8fbff;\n}\n\n.earnings-installation-details-row:hover {\n  background: #f8fbff !important;\n}\n\n.earnings-installation-details-row.is-session-details > td,\n.earnings-installation-details-row.is-session-details:hover {\n  border-bottom-color: #cbd5e1;\n  background: #e5e7eb !important;\n}\n\n.earnings-installation-details {\n  padding: 16px 18px 18px;\n}\n\n.saved-installation-items-details {\n  overflow: hidden;\n  margin-top: 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n}\n\n.saved-installation-items-toggle {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 11px 13px;\n  border: 0;\n  background: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.saved-installation-items-toggle:hover {\n  background: #f1f5f9;\n}\n\n.saved-installation-items-toggle:focus-visible {\n  outline: 2px solid #64748b;\n  outline-offset: -2px;\n}\n\n.saved-installation-items-toggle svg {\n  transition: transform 0.2s ease;\n}\n\n.saved-installation-items-details.is-expanded .saved-installation-items-toggle svg {\n  transform: rotate(180deg);\n}\n\n.saved-installation-items-content {\n  border-top: 1px solid #cbd5e1;\n}\n\n.saved-installation-items-table-wrap {\n  overflow-x: auto;\n}\n\n.settlement-items-subtable {\n  min-width: 760px;\n}\n\n.settlement-calculation-editor {\n  overflow: hidden;\n  margin-bottom: 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);\n}\n\n.settlement-calculation-editor-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 17px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.settlement-calculation-editor-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.settlement-calculation-editor-icon {\n  display: grid;\n  flex: 0 0 auto;\n  width: 38px;\n  height: 38px;\n  place-items: center;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.settlement-calculation-editor-title > div {\n  display: grid;\n  gap: 1px;\n}\n\n.settlement-calculation-editor-title h5,\n.settlement-calculation-editor-title p {\n  margin: 0;\n}\n\n.settlement-calculation-editor-title h5 {\n  color: #0f172a;\n  font-size: 15px;\n}\n\n.settlement-calculation-editor-title p {\n  color: #475569;\n  font-size: 11px;\n}\n\n.settlement-current-amount {\n  display: grid;\n  min-width: 190px;\n  gap: 1px;\n  padding-left: 20px;\n  border-left: 1px solid #dbe3ef;\n  text-align: right;\n}\n\n.settlement-current-amount span,\n.settlement-current-amount small {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.settlement-current-amount span {\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.settlement-current-amount strong {\n  color: #0f172a;\n  font-size: 18px;\n  line-height: 1.25;\n}\n\n.settlement-calculation-editor-body {\n  display: grid;\n  grid-template-columns: minmax(300px, 0.85fr) minmax(380px, 1.15fr);\n  gap: 14px;\n  padding: 18px 20px;\n}\n\n.settlement-calculation-group {\n  min-width: 0;\n  padding: 15px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.settlement-calculation-group-heading {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 13px;\n}\n\n.settlement-calculation-group-heading > span {\n  display: grid;\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  place-items: center;\n  border-radius: 7px;\n  background: #e2e8f0;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.settlement-calculation-group-heading > div {\n  display: grid;\n  gap: 1px;\n}\n\n.settlement-calculation-group-heading strong {\n  color: #1e293b;\n  font-size: 12px;\n}\n\n.settlement-calculation-group-heading small {\n  color: #64748b;\n  font-size: 10px;\n}\n\n.settlement-percentage-fields {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.settlement-percentage-fields > label,\n.settlement-target-amount {\n  display: grid;\n  gap: 6px;\n  color: #334155;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.settlement-percentage-fields > label > small {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.settlement-percentage-input {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.settlement-percentage-input:focus-within,\n.settlement-target-amount .pzl-money-input:focus-within {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.settlement-percentage-input input {\n  width: 100%;\n  min-width: 0;\n  height: 40px;\n  padding: 7px 10px;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.settlement-percentage-input > span {\n  color: #64748b;\n  padding: 0 11px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.settlement-target-group.is-active {\n  border-color: #93c5fd;\n  background: #f8fbff;\n  box-shadow: 0 0 0 1px rgba(147, 197, 253, 0.25);\n}\n\n.settlement-target-group.is-active .settlement-calculation-group-heading > span {\n  background: #2563eb;\n  color: #fff;\n}\n\n.settlement-target-controls {\n  display: grid;\n  grid-template-columns: minmax(250px, 1fr) minmax(185px, 0.65fr);\n  align-items: center;\n  gap: 18px;\n}\n\n.settlement-target-switch {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.settlement-target-switch > input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n\n.settlement-target-switch-control {\n  position: relative;\n  display: block;\n  flex: 0 0 auto;\n  width: 38px;\n  height: 22px;\n  border-radius: 999px;\n  background: #cbd5e1;\n  transition: background 0.2s ease;\n}\n\n.settlement-target-switch-control > span {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.24);\n  transition: transform 0.2s ease;\n}\n\n.settlement-target-switch > input:checked + .settlement-target-switch-control {\n  background: #2563eb;\n}\n\n.settlement-target-switch > input:checked + .settlement-target-switch-control > span {\n  transform: translateX(16px);\n}\n\n.settlement-target-switch > input:focus-visible + .settlement-target-switch-control {\n  outline: 3px solid rgba(59, 130, 246, 0.2);\n  outline-offset: 2px;\n}\n\n.settlement-target-switch-copy {\n  display: grid;\n  gap: 2px;\n}\n\n.settlement-target-switch-copy strong {\n  color: #334155;\n  font-size: 12px;\n}\n\n.settlement-target-switch-copy small {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.settlement-target-amount .pzl-money-input {\n  border-radius: 8px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.2s ease;\n}\n\n.settlement-target-amount .pzl-money-input input {\n  width: 100%;\n  min-width: 0;\n  height: 40px;\n  outline: none;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.settlement-target-amount.is-disabled {\n  opacity: 0.55;\n}\n\n.settlement-calculation-feedback {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 20px 16px;\n  padding: 10px 12px;\n  border: 1px solid;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.settlement-calculation-feedback.is-success {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n\n.settlement-calculation-feedback.is-error {\n  border-color: #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.settlement-calculation-editor-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 14px 20px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.calculation-day-additional {\n  grid-column: 1 / -1;\n  color: #047857;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: right;\n}\n\n.day-final-amount-editor {\n  display: grid;\n  grid-column: 1 / -1;\n  grid-template-columns: minmax(150px, 1fr) minmax(210px, auto) auto;\n  align-items: center;\n  gap: 10px;\n  margin-top: 6px;\n  padding: 10px;\n  border: 1px solid #bfdbfe;\n  border-radius: 9px;\n  background: #f8fbff;\n}\n\n.day-final-assignment {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.day-final-assignment strong {\n  color: #334155;\n  font-size: 12px;\n}\n\n.day-final-assignment small {\n  color: #047857;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.day-final-amount-editor label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.day-final-amount-editor .pzl-money-input {\n  flex: 0 0 154px;\n  width: 154px;\n}\n\n.day-final-amount-editor .pzl-money-input input {\n  flex: 1 1 auto;\n  width: 0;\n  min-width: 0;\n}\n\n.day-final-amount-editor .pzl-money-input > span {\n  display: inline-flex;\n  flex: 0 0 42px;\n  min-width: 42px;\n  align-items: center;\n  align-self: stretch;\n  justify-content: center;\n  padding: 0 7px;\n  border-left: 1px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.day-final-amount-action {\n  display: grid;\n  width: min(100%, 460px);\n  grid-template-columns: repeat(2, minmax(190px, 1fr));\n  justify-self: end;\n  gap: 8px;\n}\n\n.day-final-amount-action button {\n  display: inline-flex;\n  width: 100%;\n  min-height: 36px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 560px) {\n  .day-final-amount-action {\n    width: 100%;\n    grid-template-columns: 1fr;\n  }\n}\n\n.day-final-amount-feedback {\n  grid-column: 1 / -1;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: right;\n}\n\n.day-final-amount-feedback.is-success {\n  color: #047857;\n}\n\n.day-final-amount-feedback.is-error {\n  color: #b91c1c;\n}\n\n.assignment-days-final-amounts {\n  display: grid;\n  gap: 10px;\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid #dbeafe;\n}\n\n.assignment-days-final-amounts > span {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.assignment-day-final-row {\n  display: grid;\n  grid-template-columns: 100px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n}\n\n.assignment-day-final-row .day-final-amount-editor {\n  margin-top: 0;\n}\n\n@media (max-width: 900px) {\n  .day-final-amount-editor,\n  .assignment-day-final-row {\n    grid-template-columns: 1fr;\n  }\n\n  .day-final-amount-editor label {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.settlement-calculation-global-note {\n  display: flex;\n  max-width: 620px;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n.settlement-calculation-global-note svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n  color: #2563eb;\n}\n\n.settlement-calculation-global-note span {\n  display: inline;\n}\n\n.settlement-calculation-global-note strong {\n  display: block;\n  margin-bottom: 1px;\n  color: #334155;\n}\n\n.settlement-calculation-save-buttons {\n  display: grid;\n  flex: 0 0 min(100%, 520px);\n  width: min(100%, 520px);\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.settlement-calculation-save-buttons button {\n  display: inline-flex;\n  width: 100%;\n  height: 42px;\n  min-height: 42px;\n  box-sizing: border-box;\n  align-self: stretch;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  margin: 0;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  transform: none;\n  white-space: nowrap;\n}\n\n.settlement-calculation-save-buttons button:hover:not(:disabled) {\n  transform: none;\n}\n\n@media (max-width: 1080px) {\n  .settlement-calculation-editor-body {\n    grid-template-columns: 1fr;\n  }\n\n  .settlement-calculation-editor-footer {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .settlement-calculation-save-buttons {\n    align-self: flex-end;\n  }\n}\n\n@media (max-width: 640px) {\n  .settlement-calculation-editor-heading {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .settlement-current-amount {\n    padding: 10px 0 0;\n    border-top: 1px solid #dbe3ef;\n    border-left: 0;\n    text-align: left;\n  }\n\n  .settlement-percentage-fields,\n  .settlement-target-controls,\n  .settlement-calculation-save-buttons {\n    grid-template-columns: 1fr;\n  }\n\n  .settlement-calculation-editor-body,\n  .settlement-calculation-editor-heading,\n  .settlement-calculation-editor-footer {\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n}\n\n.installation-detail-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.installation-detail-summary > div {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 11px 12px;\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.installation-detail-summary span {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.installation-detail-summary strong {\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.installation-calculation {\n  margin-bottom: 14px;\n  padding: 16px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.installation-calculation-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.calculation-eyebrow {\n  display: block;\n  margin-bottom: 2px;\n  color: #2563eb;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.installation-calculation-heading h5 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 15px;\n}\n\n.calculation-position {\n  padding: 5px 9px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.calculation-flow {\n  display: grid;\n  grid-template-columns: minmax(120px, 1fr) auto minmax(120px, 1fr) auto minmax(135px, 1fr) auto minmax(110px, 0.8fr) auto minmax(135px, 1fr);\n  align-items: stretch;\n  gap: 7px;\n}\n\n.calculation-step {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  min-height: 58px;\n  padding: 9px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.calculation-step.is-highlighted {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n}\n\n.calculation-step span {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.calculation-step strong {\n  color: #0f172a;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.calculation-operator {\n  align-self: center;\n  color: #64748b;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.employee-calculation-result {\n  margin-top: 12px;\n  padding: 13px;\n  border: 1px solid #bbf7d0;\n  border-radius: 9px;\n  background: #f0fdf4;\n}\n\n.employee-calculation-meta {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.employee-calculation-meta > span {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.employee-calculation-meta strong {\n  color: #166534;\n  font-size: 13px;\n  text-transform: none;\n}\n\n.employee-calculation-formula {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 7px;\n  background: #fff;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.employee-calculation-formula strong {\n  color: #15803d;\n  font-size: 18px;\n}\n\n.calculation-days {\n  overflow: hidden;\n  border: 1px solid #dcfce7;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.calculation-days-title {\n  display: block;\n  padding: 8px 11px;\n  border-bottom: 1px solid #dcfce7;\n  background: #f7fee7;\n  color: #3f6212;\n  font-size: 11px;\n}\n\n.calculation-day-row {\n  display: grid;\n  grid-template-columns: 90px minmax(230px, 1fr) auto minmax(90px, auto);\n  align-items: center;\n  gap: 10px;\n  padding: 8px 11px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #475569;\n  font-size: 12px;\n}\n\n.calculation-day-date {\n  color: #64748b;\n  font-weight: 700;\n}\n\n.calculation-day-formula {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.calculation-day-equals {\n  color: #94a3b8;\n  font-weight: 700;\n}\n\n.calculation-day-row > strong {\n  color: #15803d;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.employee-calculation-formula.is-total {\n  justify-content: flex-end;\n  border-radius: 0;\n  background: #f0fdf4;\n}\n\n.employee-calculation-result p {\n  margin: 8px 0 0;\n  color: #64748b;\n  font-size: 10px;\n  line-height: 1.45;\n}\n\n.employee-calculation-result.is-manual > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.employee-calculation-result.is-manual span {\n  color: #166534;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.employee-calculation-result.is-manual strong {\n  color: #15803d;\n  font-size: 18px;\n}\n\n.installation-calculation.is-unavailable {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  padding: 11px 12px;\n  color: #64748b;\n}\n\n.installation-calculation.is-unavailable div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.installation-calculation.is-unavailable strong {\n  color: #475569;\n  font-size: 12px;\n}\n\n.installation-calculation.is-unavailable span {\n  font-size: 11px;\n}\n\n.installation-usl-form {\n  display: grid;\n  grid-template-columns: minmax(190px, 0.7fr) minmax(240px, 1.3fr) auto;\n  gap: 11px;\n  align-items: end;\n  padding: 13px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  background: #fff;\n}\n\n.installation-usl-form-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  grid-column: 1 / -1;\n}\n\n.installation-usl-form-heading strong {\n  color: #1e293b;\n  font-size: 13px;\n}\n\n.installation-usl-form-heading span {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.installation-usl-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.installation-usl-form input {\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.installation-usl-form input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.installation-usl-form button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 38px;\n  white-space: nowrap;\n}\n\n.installation-usl-error {\n  grid-column: 1 / -1;\n  color: #b91c1c;\n  font-size: 11px;\n}\n\n.snapshot-usl-note {\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.earned-cell {\n  font-weight: 700;\n  color: #16a34a;\n}\n\n.total-row {\n  background: #f0fdf4 !important;\n}\n\n.total-row td {\n  border-top: 2px solid #bbf7d0;\n  padding: 10px 12px;\n}\n\n@media (max-width: 800px) {\n  .installation-detail-summary,\n  .installation-usl-form {\n    grid-template-columns: 1fr;\n  }\n\n  .installation-calculation-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .calculation-flow {\n    grid-template-columns: 1fr;\n  }\n\n  .calculation-operator {\n    transform: rotate(90deg);\n    justify-self: center;\n  }\n\n  .employee-calculation-meta {\n    grid-template-columns: 1fr;\n  }\n\n  .employee-calculation-formula {\n    flex-wrap: wrap;\n  }\n\n  .calculation-day-row {\n    grid-template-columns: 1fr auto;\n  }\n\n  .calculation-day-formula {\n    grid-column: 1 / -1;\n    grid-row: 2;\n  }\n\n  .calculation-day-equals {\n    display: none;\n  }\n\n  .installation-usl-form button {\n    width: 100%;\n  }\n}\n\n/* Shared */\n.error-banner {\n  background: #fee2e2;\n  color: #991b1b;\n  padding: 10px 14px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 13px;\n  cursor: pointer;\n  border: 1px solid #fca5a5;\n}\n\n.loading-text {\n  color: #64748b;\n  padding: 24px;\n  text-align: center;\n  font-style: italic;\n}\n\n/* Data table (shared) */\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.data-table th {\n  background: #f1f5f9;\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n.data-table td {\n  padding: 8px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #374151;\n}\n.data-table tbody tr:hover { background: #f8fafc; }\n\n.no-data-cell {\n  text-align: center;\n  color: #94a3b8;\n  padding: 24px;\n  font-style: italic;\n}\n.no-data-text { color: #94a3b8; font-style: italic; font-size: 13px; }\n.numeric-cell { text-align: right; }\n.actions-cell { white-space: nowrap; }\n.actions-cell button { margin-left: 4px; }\n.installer-position { font-size: 12px; color: #64748b; }\n\n/* Unassigned installations warning */\n.unassigned-warning {\n  border: 1.5px solid #fde68a;\n  border-radius: 10px;\n  background: #fffbeb;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n.unassigned-warning-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: #fef9c3;\n  border-bottom: 1px solid #fde68a;\n  flex-wrap: wrap;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.unassigned-warning-header:hover {\n  background: #fef3c7;\n}\n.unassigned-warning-header:focus-visible {\n  outline: 2px solid #d97706;\n  outline-offset: -2px;\n}\n.unassigned-warning.is-collapsed .unassigned-warning-header {\n  border-bottom: 0;\n}\n.unassigned-warning-badge {\n  background: #f59e0b;\n  color: #fff;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.unassigned-warning-copy {\n  display: flex;\n  min-width: 240px;\n  flex: 1 1 520px;\n  flex-direction: column;\n  gap: 2px;\n}\n.unassigned-warning-hint {\n  font-size: 12px;\n  color: #92400e;\n}\n.unassigned-warning-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 34px;\n  margin-left: auto;\n  padding: 6px 10px;\n  border: 1px solid #f59e0b;\n  border-radius: 7px;\n  background: #fff;\n  color: #92400e;\n  pointer-events: none;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n.unassigned-warning-toggle:hover {\n  background: #fffbeb;\n}\n.unassigned-warning-toggle:focus-visible {\n  outline: 2px solid #d97706;\n  outline-offset: 2px;\n}\n.unassigned-warning-toggle svg {\n  transition: transform 0.2s ease;\n}\n.unassigned-warning.is-expanded .unassigned-warning-toggle svg {\n  transform: rotate(180deg);\n}\n.unassigned-warning-content {\n  overflow-x: auto;\n}\n.unassigned-warning .data-table { margin: 0; }\n.unassigned-warning .data-table td,\n.unassigned-warning .data-table th {\n  padding: 8px 12px;\n  font-size: 13px;\n  text-align: center;\n  vertical-align: middle;\n}\n.order-cell { font-weight: 600; font-family: monospace; }\n\n/* All installations in the selected settlement period */\n.period-installations-card {\n  margin-bottom: 20px;\n  overflow: hidden;\n  border: 1px solid #dbe4ef;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 14px rgb(15 23 42 / 4%);\n}\n\n.period-installations-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 16px 18px;\n  border: 0;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.period-installations-header:hover {\n  background: #f1f5f9;\n}\n\n.period-installations-header:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: -2px;\n}\n\n.period-installations-card.is-collapsed .period-installations-header {\n  border-bottom: 0;\n}\n\n.period-installations-header h4 {\n  margin: 0 0 3px;\n  color: #0f172a;\n  font-size: 15px;\n}\n\n.period-installations-header p {\n  max-width: 760px;\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.period-installations-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  height: 34px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.period-installations-header-actions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 9px;\n}\n\n.period-installations-section-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 34px;\n  padding: 6px 10px;\n  border: 1px solid #818cf8;\n  border-radius: 7px;\n  background: #fff;\n  color: #4338ca;\n  pointer-events: none;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.period-installations-section-toggle:hover {\n  background: #eef2ff;\n}\n\n.period-installations-section-toggle:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: 2px;\n}\n\n.period-installations-section-toggle svg {\n  transition: transform 0.2s ease;\n}\n\n.period-installations-card.is-expanded .period-installations-section-toggle svg {\n  transform: rotate(180deg);\n}\n\n.period-installations-state {\n  padding: 28px 18px;\n  color: #64748b;\n  font-size: 13px;\n  text-align: center;\n}\n\n.period-installations-table-wrap {\n  overflow-x: auto;\n}\n\n.period-installations-table {\n  min-width: 850px;\n  margin: 0;\n}\n\n.period-installations-table th,\n.period-installations-table td {\n  padding: 10px 12px;\n  font-size: 13px;\n}\n\n.period-installations-table > thead > tr > th,\n.period-installations-table > tbody > .period-installation-row > td {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.period-installation-row {\n  cursor: pointer;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.period-installation-row:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: -2px;\n}\n\n.period-installation-row.is-expanded:not(.has-zero-usl) {\n  background: #eef2ff;\n}\n\n.period-installation-row.has-zero-usl,\n.period-installation-row.has-zero-usl:hover {\n  background: #fff1f2;\n}\n\n.period-installation-row.has-zero-usl td:first-child {\n  box-shadow: inset 3px 0 0 #fb7185;\n}\n\n.period-installation-usl {\n  color: #166534;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.period-installation-usl.is-zero {\n  color: #be123c;\n}\n\n.period-installation-actions {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.period-installation-actions button,\n.period-usl-entry button,\n.period-usl-form-actions button,\n.period-usl-add-form button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.period-installation-toggle svg {\n  transition: transform 0.2s ease;\n}\n\n.period-installation-toggle.is-expanded svg {\n  transform: rotate(180deg);\n}\n\n.period-installation-editor-row > td {\n  padding: 0 !important;\n  border-bottom-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.period-usl-editor {\n  padding: 16px 20px 18px;\n  border-left: 3px solid #6366f1;\n}\n\n.period-installation-breakdown {\n  margin-bottom: 16px;\n  overflow: hidden;\n  border: 1px solid #c7d2fe;\n  border-radius: 9px;\n  background: #fff;\n}\n\n.period-installation-breakdown-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 11px 13px;\n  border-bottom: 1px solid #e0e7ff;\n  background: #eef2ff;\n}\n\n.period-installation-breakdown.is-collapsible .period-installation-breakdown-heading {\n  width: 100%;\n  border: 0;\n  border-bottom: 1px solid #e0e7ff;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.period-installation-breakdown.is-collapsed .period-installation-breakdown-heading {\n  border-bottom: 0;\n}\n\n.period-installation-breakdown-heading > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.period-installation-breakdown-heading strong {\n  color: #312e81;\n  font-size: 13px;\n}\n\n.period-installation-breakdown-heading span {\n  color: #6366f1;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.period-installation-breakdown-heading > .period-installation-breakdown-heading-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  white-space: nowrap;\n}\n\n.period-installation-breakdown-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.period-installation-breakdown-toggle svg {\n  transition: transform 0.2s ease;\n}\n\n.period-installation-breakdown.is-expanded .period-installation-breakdown-toggle svg {\n  transform: rotate(180deg);\n}\n\n.period-installation-breakdown-table-wrap {\n  overflow-x: auto;\n}\n\n.period-installation-breakdown-table {\n  width: 100%;\n  min-width: 620px;\n  border-collapse: collapse;\n}\n\n.period-installation-breakdown-table th,\n.period-installation-breakdown-table td {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eef2f7;\n  color: #475569;\n  font-size: 12px;\n  text-align: left;\n}\n\n.period-installation-breakdown-table th {\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 10px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.period-installation-breakdown-table .numeric-cell {\n  text-align: center;\n}\n\n.period-installation-breakdown-table tbody strong {\n  color: #1e293b;\n}\n\n.period-installation-breakdown-table tfoot td {\n  border-bottom: 0;\n  background: #f8fafc;\n  color: #0f172a;\n  font-weight: 800;\n}\n\n.period-installation-breakdown-empty {\n  padding: 16px;\n  color: #64748b;\n  font-size: 12px;\n  text-align: center;\n}\n\n.period-usl-editor-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.period-usl-editor-heading > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.period-usl-editor-heading strong {\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.period-usl-editor-heading span,\n.period-usl-no-entries {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.period-usl-no-entries {\n  padding: 5px 9px;\n  border-radius: 6px;\n  background: #e2e8f0;\n}\n\n.period-usl-entries {\n  display: grid;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.period-usl-entry {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 9px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.period-usl-entry > div:not(.period-usl-form-actions) {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.period-usl-entry strong {\n  overflow: hidden;\n  color: #334155;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.period-usl-entry span {\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.period-usl-inline-form,\n.period-usl-add-form {\n  display: grid;\n  width: 100%;\n  grid-template-columns: minmax(130px, 0.45fr) minmax(220px, 1fr) auto;\n  align-items: end;\n  gap: 10px;\n}\n\n.period-usl-add-form {\n  padding: 12px;\n  border: 1px dashed #a5b4fc;\n  border-radius: 9px;\n  background: #eef2ff;\n}\n\n.period-usl-inline-form label,\n.period-usl-add-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.period-usl-inline-form input,\n.period-usl-add-form input {\n  min-width: 0;\n  height: 36px;\n  padding: 7px 9px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  color: #0f172a;\n  font: inherit;\n  font-size: 13px;\n}\n\n.period-usl-inline-form input:focus,\n.period-usl-add-form input:focus {\n  outline: 2px solid #c7d2fe;\n  border-color: #6366f1;\n}\n\n.period-usl-form-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.period-usl-error {\n  margin-top: 8px;\n  color: #be123c;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n@media (max-width: 760px) {\n  .period-installations-header,\n  .period-usl-editor-heading {\n    align-items: flex-start;\n  }\n\n  .period-installations-header {\n    flex-wrap: wrap;\n  }\n\n  .period-installations-header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .period-usl-inline-form,\n  .period-usl-add-form {\n    grid-template-columns: 1fr;\n  }\n\n  .period-usl-form-actions {\n    justify-content: flex-start;\n  }\n}\n\n/* Buttons */\n.btn-primary {\n  background: #2563eb;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.15s;\n}\n.btn-primary:hover { background: #1d4ed8; }\n.btn-primary:disabled { background: #93c5fd; cursor: not-allowed; }\n\n.btn-secondary {\n  background: #f1f5f9;\n  color: #374151;\n  border: 1px solid #cbd5e1;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.15s;\n}\n.btn-secondary:hover { background: #e2e8f0; }\n\n.btn-success {\n  background: #16a34a;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.btn-success:hover { background: #15803d; }\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.btn-danger:hover { background: #dc2626; }\n\n.btn-sm { padding: 4px 10px; font-size: 12px; }\n\n.position-rate-actions .position-action-btn {\n  margin-left: 0;\n  padding: 7px 11px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.position-rate-actions .position-action-btn:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.position-rate-actions .position-edit-btn,\n.position-rate-actions .position-cancel-btn {\n  width: max-content;\n  min-height: auto;\n  flex: 0 0 auto;\n  padding: 3px 6px;\n  font-size: 12px;\n}\n\n.position-rate-actions .position-edit-btn {\n  border-color: transparent;\n  background: transparent;\n}\n\n.position-rate-actions .position-edit-btn:hover {\n  border-color: #cbd5e1;\n  background: #f1f5f9;\n}\n.pzl-price-list-step-heading {\n  display: flex;\n  gap: 11px;\n  align-items: center;\n  padding: 18px 0 12px;\n}\n\n.pzl-price-list-step-heading > span {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #7c3aed;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.pzl-price-list-step-heading h4,\n.pzl-price-list-step-heading p {\n  margin: 0;\n}\n\n.pzl-price-list-step-heading h4 {\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.pzl-price-list-step-heading p {\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.pzl-price-list-step-heading.is-compact {\n  padding-top: 0;\n}\n\n.pzl-price-list-form,\n.pzl-order-editor {\n  display: grid;\n  gap: 16px;\n}\n\n.pzl-price-list-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.pzl-price-option {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 34px;\n  padding: 7px 12px;\n  border: 1px solid #dbe3ef;\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.pzl-price-option input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n\n.pzl-price-option.is-selected {\n  border-color: #7c3aed;\n  background: #f5f3ff;\n  color: #6d28d9;\n  box-shadow: 0 0 0 1px #7c3aed;\n}\n\n.pzl-price-option span,\n.pzl-price-option small,\n.pzl-order-editor-heading > div {\n  display: grid;\n  gap: 4px;\n}\n\n.pzl-price-option small,\n.pzl-order-editor-heading span {\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.pzl-price-list-actions,\n.pzl-order-editor-controls,\n.pzl-order-editor-heading,\n.pzl-order-editor-actions {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.pzl-price-list-actions,\n.pzl-order-editor-actions {\n  justify-content: flex-start;\n}\n\n.pzl-order-editor-actions {\n  display: grid;\n  justify-items: start;\n  width: 100%;\n  gap: 10px;\n}\n\n.pzl-order-save-success {\n  color: #15803d;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pzl-order-save-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.pzl-order-save-buttons.has-two-actions {\n  display: grid;\n  width: min(100%, 560px);\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.pzl-order-save-buttons.has-two-actions button {\n  justify-content: center;\n  width: 100%;\n  min-height: 36px;\n}\n\n.pzl-order-global-note {\n  margin: -4px 0 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.pzl-price-list-actions label,\n.pzl-order-editor-controls label {\n  display: grid;\n  gap: 6px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pzl-money-input {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n}\n\n.pzl-money-input input {\n  width: 110px;\n  height: 34px;\n  padding: 6px 9px;\n  border: 0 !important;\n}\n\n.pzl-money-input > span {\n  padding: 0 10px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pzl-price-list-success {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.pzl-price-current-value {\n  flex: 1;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.saved-session-pzl-price-list {\n  overflow: hidden;\n  border: 1px solid #c4b5fd;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #fff 0%, #faf5ff 100%);\n}\n\n.saved-session-pzl-toggle {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  padding: 16px 18px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.saved-session-pzl-toggle:hover {\n  background: rgba(245, 243, 255, 0.75);\n}\n\n.saved-session-pzl-heading-copy {\n  display: grid;\n  gap: 3px;\n}\n\n.saved-session-pzl-heading-copy strong {\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.saved-session-pzl-toggle-action {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.saved-session-pzl-content {\n  display: grid;\n  gap: 14px;\n  padding: 16px 18px 18px;\n  border-top: 1px solid #ddd6fe;\n}\n\n.saved-session-pzl-description {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.pzl-price-list-form.is-session {\n  padding-top: 4px;\n}\n\n.pzl-order-editor {\n  margin: 14px 0;\n  padding: 14px;\n  border: 1px solid #ddd6fe;\n  border-radius: 10px;\n  background: #faf5ff;\n}\n\n.pzl-order-editor-heading {\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.pzl-source-badge {\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #ede9fe;\n  color: #6d28d9 !important;\n  font-weight: 700;\n}\n\n.pzl-source-badge.is-override {\n  background: #ffedd5;\n  color: #c2410c !important;\n}\n\n.pzl-use-price-list {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pzl-inline-badge {\n  display: block;\n  width: fit-content;\n  margin-top: 4px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: #ede9fe;\n  color: #6d28d9;\n  font-size: 10px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.note-settlement-editor {\n  margin: 14px 0;\n}\n\n.note-settlement-mode-options,\n.note-settlement-manual-amounts {\n  display: grid;\n  gap: 10px;\n}\n\n.note-settlement-mode-options label {\n  display: flex;\n  gap: 9px;\n  align-items: center;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.note-settlement-equal-amount,\n.note-settlement-manual-amounts label {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.note-settlement-manual-amounts label {\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n@media (max-width: 700px) {\n  .note-settlement-equal-amount,\n  .note-settlement-manual-amounts label {\n    align-items: stretch;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 900px) {\n  .pzl-price-list-actions,\n  .pzl-order-editor-controls,\n  .pzl-order-editor-heading {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .saved-session-pzl-toggle-action .pzl-source-badge {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
